import React from "react";

const StatisticsCard = ({ label, value, description, icon }) => (
	<div className="bg-white p-4 rounded-lg border border-gray-100">
		<div className="flex items-center justify-between">
			<div className="flex flex-col">
				<div className="text-sm font-medium text-gray-500">{label}</div>
				<div className="flex items-center gap-2 mt-1">
					<div className="text-2xl font-semibold text-gray-900">{value}</div>
				</div>
				{description && (
					<div className="text-[13px] text-emerald-600 font-medium leading-tight mt-1.5">{description}</div>
				)}
			</div>
			<div className="rounded-lg bg-primary-50 p-2">{icon}</div>
		</div>
	</div>
);

export default StatisticsCard;
